import { type StudyMoeSelectDto, type StudyMosSelectDto } from '@@types/api.types';
import { Modal } from '@components/core/modal.component';
import { ConfirmationModal } from '@components/shared/confirm-delete-modal.component';
import { type FC, useState } from 'react';
import { MeiaMosForm } from './meia-mos-form.component';

export type MeiaMosTree = {
  moes: StudyMoeSelectDto[];
  mos: StudyMosSelectDto;
};

type MeiaMosModalProps = {
  isOpen: boolean;
  missionId: string;
  mosTree?: MeiaMosTree;
  onClose: () => void;
};

export const MeiaMosModal: FC<MeiaMosModalProps> = (props) => {
  const { isOpen, missionId, mosTree, onClose } = props;
  const [isConfirmingClose, setIsConfirmingClose] = useState(false);

  return (
    <MeiaMosForm
      missionId={missionId}
      moes={mosTree?.moes ?? []}
      mos={mosTree?.mos}
      onSaved={onClose}
    >
      {({ deleteButton, getIsDirty, isEdit, isSaving, mosForm, mosTemplatePopover, submit }) => {
        // Guard close paths (button, overlay, Escape) when the form has unsaved edits.
        const requestClose = (): void => {
          if (getIsDirty()) {
            setIsConfirmingClose(true);
            return;
          }
          onClose();
        };

        return (
          <>
            <Modal
              centered
              footer={{
                leftButton: deleteButton,
                rightButton: {
                  children: isSaving ? 'Saving...' : isEdit ? 'Save' : 'Add Measure',
                  disabled: isSaving,
                  onClick: submit,
                },
              }}
              header={{
                actions: mosTemplatePopover,
                title: isEdit ? 'Edit Measure of Success' : 'Add Measure of Success',
              }}
              isOpen={isOpen}
              onClose={requestClose}
              width="720px"
            >
              {mosForm}
            </Modal>
            <ConfirmationModal
              cancelLabel="Keep Editing"
              confirmLabel="Discard Changes"
              description="Closing now will discard the unsaved Measure of Success edits."
              isOpen={isConfirmingClose}
              onConfirm={onClose}
              setIsOpen={setIsConfirmingClose}
              title="Discard unsaved changes?"
            />
          </>
        );
      }}
    </MeiaMosForm>
  );
};
